<main class="main-container">
  <div class="agent-logged-out-wrapper">
    <section class="logged-out-card-wrapper">
      <div class="logged-out-card">
        <div class="logged-out-icon">
          <img src="/assets/images/bnb-building-withbg.svg" alt="agent" class="d-none d-lg-block">
          <img src="/assets/images/420.svg" alt="agent" class="d-block d-lg-none">
        </div>
        <div class="logged-out-content">
          <h2 class="logged-out-title">Logged out successfully</h2>
        </div>
      </div>
    </section>
  </div>
</main>
